export function upsertById<T extends { id: string }>(arr: T[], item: T): T[] {
  const idx = arr.findIndex((i) => i.id === item.id);
  if (idx === -1) return [item, ...arr]; // prepend new
  const next = arr.slice();
  next[idx] = { ...next[idx], ...item }; // shallow merge
  return next;
}
